import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { updatearrangementen, getarrangementen } from "../Reducers/actions";
import { message } from "../../../Reducers/loading/actions";
import LogboekEditForm from "../Components/wanneer";
import { Link, useParams, useNavigate } from "react-router-dom";
import SneaTabs from "../../../Components/SneaTabs";
const ArrangementenEditWanneerPage = ({ updatearrangementen, getarrangementen, message }) => {
  const [loaded, setLoaded] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  const submit = (vals) => {
    updatearrangementen(params.id, vals).then((data) => {
      if (data.type === "FACILIEIT_ERROR") {
        alert(data.payload);
        return false;
      } else {
        message(3000, "success", "De ervaring is met succes aangepast").then((data) => {
          navigate("/arrangementen/edit/beschikbaarheid/" + params.id);
        });
      }
    });
  };

  const tabs = [
    {
      id: 'wat',
      label: 'Wat',
      content: null
    },
    {
      id: 'waar',
      label: 'Waar',
      content: null
    },
    {
      id: 'media',
      label: 'Media',
      content: null
    },
    {
      id: 'items',
      label: 'Items',
      content: loaded && <LogboekEditForm onSubmit={submit} />
    },
    {
      id: 'beschikbaarheid',
      label: 'Beschikbaarheid',
      content: null
    },
    {
      id: 'eigenschappen',
      label: 'Eigenschappen',
      content: null
    },
    {
      id: 'communicatie',
      label: 'Communicatie',
      content: null
    }
  ];

  const handleTabChange = (tabId, index) => {
    const routes = {
      'wat': `/arrangementen/edit/${params.id}`,
      'waar': `/arrangementen/edit/waar/${params.id}`,
      'media': `/arrangementen/edit/media/${params.id}`,
      'items': `/arrangementen/edit/items/${params.id}`,
      'beschikbaarheid': `/arrangementen/edit/beschikbaarheid/${params.id}`,
      'eigenschappen': `/arrangementen/edit/eigenschappen/${params.id}`,
      'communicatie': `/arrangementen/edit/communicatie/${params.id}`
    };
    if (routes[tabId]) {
      navigate(routes[tabId]);
    }
  };
  useEffect(() => {
    setLoaded(false);
    getarrangementen(params.id).then((data) => {
      if (data.results) {
        setLoaded(true);
      } else {
        message(3000, "warning", "Er is een fout opgetreden bij het laden van de activiteit").then((data) => {
          navigate("/logboek");
        });
      }
    });
  }, [getarrangementen, params.id, message]);

  return (
    <div className="box box-default">
      <div className="box-header with-border">
      <h3 className="box-title"> Arrangement wijzigen</h3>
      </div>
      <div className="row">
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body wizard">
              <SneaTabs
                tabs={tabs}
                defaultActiveTab={3}
                variant="default"
                onTabChange={handleTabChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return { username: state.auth.user, arrangementen: state.arrangementen.item };
}

export default connect(mapStateToProps, {
  updatearrangementen,
  getarrangementen,
  message,
})(ArrangementenEditWanneerPage);
